import React, { useState, useEffect, useContext, useCallback } from 'react';
import { CBadge, CSidebar, CSidebarBrand, CSidebarNav, CSidebarToggler } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { AppSidebarNav } from './AppSidebarNav';
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';
//import '../views/widgets/music-widget.css'
import moment from 'moment';
import '../scss/main.scss';
import avatar8 from '../assets/images/mie_sprite.png';
import logoNegative from '../assets/images/BACK-DESIGN.svg';
import { withFirebase } from 'src/views/firebase';
import { AuthUserContext } from 'src/views/session';
import getNavItems from '../_navmie'; // Import the nav items function
import { ActiveLinkContext } from './ActiveLinkContext'; // Import the context
import CloseIcon from '@mui/icons-material/Close'; // Close icon for mobile
import { IconButton } from '@mui/material'; // Import Material UI IconButton
import MenuIcon from '@mui/icons-material/Menu'; // Hamburger menu icon
import MusicWidget from '../views/widgets/MusicWidget'; // Adjust the import path as needed
import {
  CAvatar,
  CDropdown,
  CDropdownDivider,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from '@coreui/react';
import { cilMusicNote } from '@coreui/icons';
import { cilLockLocked, cilUser } from '@coreui/icons';
import { useNavigate } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';
import { CButton, CSpinner } from '@coreui/react';
import SidebarGptWidget from '../views/widgets/SidebarGptWidget'; // Update import
import { MusicPlayerContext } from '../views/widgets/MusicPlayerContext';


const AppSidebar = ({ firebase }) => {
  const [sidebarShow, setSidebarShow] = useState(true); // Set initial state to true
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false); // Controls collapsed state
  const [isMobile, setIsMobile] = useState(false);
  const [profilePic, setProfilePic] = useState(null);
  const { setActiveLink } = useContext(ActiveLinkContext); // Use the context
  const [currentTime, setCurrentTime] = useState(moment().format('LLLL')); // Initialize with current date/time
  const { authUser } = useContext(AuthUserContext);
  const googleAccessToken = localStorage.getItem('googleAccessToken');
  const navigate = useNavigate();
  const auth = getAuth();
  const [userICO, setUserICO] = useState(avatar8);
  const [userDN, setUserDN] = useState("User");
  const [musicOpen, setMusicOpen] = useState(false);
  const {
    playlistTracks,
    currentTrackIndex,
    setCurrentTrackIndex,
    isPlaying,
    setIsPlaying,
    isShuffling,
    setIsShuffling,
    playerRef,
  } = useContext(MusicPlayerContext);
  const appleAccessToken = localStorage.getItem('appleAccessToken');
  const getActiveProvider = () => (googleAccessToken ? 'google' : appleAccessToken ? 'apple' : null);
  // Update the toggle function to manage the collapsed state
  const toggleSidebar = () => {
    //setSidebarShow(!sidebarShow);
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const handleSignOut = async () => {
    try {
      localStorage.clear();
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error('Sign-out error:', error);
    }
  };


  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      // Automatically close sidebar on mobile
      if (window.innerWidth < 768) {
        setSidebarShow(false);
        setSidebarCollapsed(false); // Reset collapsed state on mobile
      } else {
        setSidebarShow(true);
        setSidebarCollapsed(false); // Keep sidebar expanded on desktop
      }
    };

    window.addEventListener("resize", handleResize);

    // Initial check
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchProfilePic = async () => {
      // Check if authUser exists first
      if (!authUser) {
        // Set default values for public users
        setProfilePic(avatar8);
        setUserDN("Guest User");
        return;
      }

      // For authenticated users, safely access properties with optional chaining
      const uid = authUser?.uid || "UnknownUID";
      const displayName = authUser?.displayName ||
        authUser?.username ||
        authUser?.mieDisplayName ||
        authUser?.email?.split('@')[0] ||
        "Guest User";
      const email = authUser?.email || "UnknownEmail";
      const photoURL = authUser?.photoURL || avatar8;

      if (photoURL) {
        setProfilePic(photoURL);
      }
      setUserDN(displayName);
    };

    fetchProfilePic();
  }, [authUser]);


  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(moment().format('LLLL'));
    }, 1000); // Update every second (1000 milliseconds)

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  // Handle navigation clicks
  const handleNavClick = (link) => {
    setActiveLink(link);
    // Optionally, close the sidebar on mobile after navigation
    if (isMobile) {
      setSidebarShow(false);
    }
  };
  // Toggle sidebar collapsed state
  const toggleSidebarCollapsed = () => {
    setSidebarCollapsed(!sidebarCollapsed);

  };

  const handleMusicControl = useCallback((action) => {
    const activeMusicSource = localStorage.getItem('musicSource') || 'youtube';
    if (activeMusicSource === 'apple') {
      window.dispatchEvent(new CustomEvent('mie:music-control-apple', { detail: { action } }));
      return;
    }

    switch (action) {
      case 'toggle':
        if (!playerRef.current) return;
        if (isPlaying) {
          playerRef.current.pauseVideo?.();
          setIsPlaying(false);
          localStorage.setItem('isPlaying', 'false');
        } else {
          playerRef.current.playVideo?.();
          setIsPlaying(true);
          localStorage.setItem('isPlaying', 'true');
        }
        return;
      case 'previous':
        if (!playlistTracks.length) return;
        {
          const newIndex = isShuffling
            ? Math.floor(Math.random() * playlistTracks.length)
            : (currentTrackIndex - 1 + playlistTracks.length) % playlistTracks.length;
          setCurrentTrackIndex(newIndex);
          setIsPlaying(true);
          localStorage.setItem('currentTrackIndex', String(newIndex));
          localStorage.setItem('isPlaying', 'true');
        }
        return;
      case 'next':
        if (!playlistTracks.length) return;
        {
          const newIndex = isShuffling
            ? Math.floor(Math.random() * playlistTracks.length)
            : (currentTrackIndex + 1) % playlistTracks.length;
          setCurrentTrackIndex(newIndex);
          setIsPlaying(true);
          localStorage.setItem('currentTrackIndex', String(newIndex));
          localStorage.setItem('isPlaying', 'true');
        }
        return;
      case 'stop':
        playerRef.current?.pauseVideo?.();
        setIsPlaying(false);
        localStorage.setItem('isPlaying', 'false');
        return;
      case 'shuffle':
        setIsShuffling((prev) => {
          const next = !prev;
          localStorage.setItem('isShuffling', String(next));
          return next;
        });
        return;
      default:
        return;
    }
  }, [currentTrackIndex, isPlaying, isShuffling, playerRef, playlistTracks.length, setCurrentTrackIndex, setIsPlaying, setIsShuffling]);

  useEffect(() => {
    const onMusicControl = (event) => {
      const action = event?.detail?.action;
      if (action) handleMusicControl(action);
    };
    window.addEventListener('mie:music-control', onMusicControl);
    return () => window.removeEventListener('mie:music-control', onMusicControl);
  }, [handleMusicControl]);

  return (
    <>
      {/* Move the IconButton outside the CSidebar component */}
      {isMobile && (
        <IconButton
          onClick={() => setSidebarShow(!sidebarShow)}
          className="mobile-toggle-button"
          aria-label="Toggle sidebar"
          sx={{
            position: 'fixed !important',
            bottom: '20px !important',
            right: '20px !important',
            top: 'auto !important',
            left: 'auto !important',
            zIndex: 1050,
            backgroundColor: 'rgba(10, 22, 40, 0.9)',
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
            transition: 'all 0.3s ease',
            color: '#F1F5F9',
            '&:hover': {
              backgroundColor: 'rgba(0, 212, 255, 0.15)',
            }
          }}
        >
          {sidebarShow ? <CloseIcon /> : <MenuIcon />}
        </IconButton>
      )}

      <CSidebar
        className={`app-sidebar ${sidebarShow ? 'visible' : ''}`}
        position="fixed"
        visible={sidebarShow}
        unfoldable={false}
        narrow={sidebarCollapsed}
      >
        {/* SVG container */}
        <div className="svg-container">
          <svg id="back-design" version="1.0" xmlns="http://www.w3.org/2000/svg"
            width="100%" height="100%" viewBox="0 0 4500 5400"
            preserveAspectRatio="xMidYMid meet">

            {/* Move "MiEROS" text up */}
            <text x="2250" y="600" textAnchor="middle" fontFamily="'Space Grotesk', 'Inter', sans-serif" fontSize="1200" fill="#00D4FF">
              <tspan className="letter-m" dx="-100">M</tspan>
              <tspan className="letter-i" dx="10">i</tspan>
              <tspan className="letter-e" dx="10">E</tspan>
              <tspan className="letter-r" dx="10">R</tspan>
              <tspan className="letter-o" dx="10">O</tspan>
              <tspan className="letter-s" dx="10">S</tspan>
            </text>
            <path className="animated-path" d="M150 0 L75 200 L225 200 Z" />
            <path className="animated-path" d="M300 50 L150 250 L450 250 Z" />

            {/* <!-- Additional paths for a visually appealing flow --> */}

            {/* <!-- Horizontal Line Pattern --> */}
            <path className="animated-path" d="M100 500 L1000 500" />
            <path className="animated-path" d="M100 600 L1000 600" />
            <path className="animated-path" d="M100 700 L1000 700" />

            {/* <!-- Vertical Line Pattern --> */}
            <path className="animated-path" d="M500 100 L500 1000" />
            <path className="animated-path" d="M600 100 L600 1000" />
            <path className="animated-path" d="M700 100 L700 1000" />

            {/* <!-- Diagonal Lines --> */}
            <path className="animated-path" d="M1000 0 L2000 1000" />
            <path className="animated-path" d="M1200 0 L2200 1000" />

            {/* <!-- Concentric Circles --> */}
            <circle className="animated-path" cx="2250" cy="1500" r="100" />
            <circle className="animated-path" cx="2250" cy="1500" r="200" />
            <circle className="animated-path" cx="2250" cy="1500" r="300" />

            {/* <!-- Additional Decorative Shapes --> */}
            <path className="animated-path" d="M2500 2000 L2700 2200 L2900 2000 L2700 1800 Z" />
            <path className="animated-path" d="M3000 2500 L3200 2700 L3400 2500 L3200 2300 Z" />

            {/* <!-- Small Circle Pattern at Bottom --> */}
            <circle className="animated-path" cx="350" cy="5200" r="50" />
            <circle className="animated-path" cx="550" cy="5200" r="50" />
            <circle className="animated-path" cx="750" cy="5200" r="50" />
            <circle className="animated-path" cx="950" cy="5200" r="50" />

            {/* <!-- Zigzag Line Pattern --> */}
            <path className="animated-path"
              d="M1000 3000 L1100 3100 L1200 3000 L1300 3100 L1400 3000 L1500 3100" />
            <path className="animated-path"
              d="M1600 3200 L1700 3300 L1800 3200 L1900 3300 L2000 3200 L2100 3300" />

            {/* <!-- Central Hexagon Shapes --> */}
            <path className="animated-path" d="M2700 3500 L2900 3600 L3100 3500 L2900 3400 Z" />
            <path className="animated-path" d="M2900 3700 L3100 3800 L3300 3700 L3100 3600 Z" />

            {/* <!-- Additional circles for symmetry --> */}
            <circle className="animated-path" cx="1500" cy="1500" r="50" />
            <circle className="animated-path" cx="3500" cy="1500" r="50" />

          </svg>
        </div>

        <div className="sidebar-brand d-flex flex-column align-items-center">
          <div style={{ position: 'relative', width: '100%', textAlign: 'center' }}>
            <div className="profile-section" style={{
              marginTop: sidebarCollapsed ? '-16rem' : '-14rem',
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: sidebarCollapsed ? '0.5rem' : '1rem'
            }}>
              <CDropdown>
                <CDropdownToggle className="p-0" caret={false}>
                  <CAvatar
                    src={profilePic}
                    size={sidebarCollapsed ? "md" : "xl"}
                    style={{
                      width: sidebarCollapsed ? '60px' : '120px',
                      height: sidebarCollapsed ? '60px' : '120px',
                      border: '3px solid #fff',
                      boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease'
                    }}
                  />
                </CDropdownToggle>
                <CDropdownMenu>
                  {authUser ? (
                    <>
                      <CDropdownItem 
                        onClick={() => handleNavClick('profile')}
                        style={{ cursor: 'pointer' }}
                        component="div"
                      >
                        <CIcon icon={cilUser} className="me-2" />
                        Profile
                      </CDropdownItem>
                      <CDropdownDivider />
                      <CDropdownItem 
                        onClick={handleSignOut}
                        style={{ cursor: 'pointer' }}
                        component="div"
                      >
                        <CIcon icon={cilLockLocked} className="me-2" />
                        Logout
                      </CDropdownItem>
                    </>
                  ) : (
                    <CDropdownItem 
                      onClick={() => navigate('/login')}
                      style={{ cursor: 'pointer' }}
                      component="div"
                    >
                      <CIcon icon={cilUser} className="me-2" />
                      Login
                    </CDropdownItem>
                  )}
                </CDropdownMenu>
              </CDropdown>
              {!sidebarCollapsed && (
                <div style={{ marginTop: '0.5rem', color: '#F1F5F9', fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" }}>
                  <h4 style={{ margin: '0', fontFamily: "'Space Grotesk', 'Inter', sans-serif", fontWeight: 600 }}>{userDN}</h4>
                </div>
              )}
            </div>
          </div>
        </div>

        <CSidebarNav className="sidebar-svg-background">
          <SimpleBar>
            <AppSidebarNav items={getNavItems(handleNavClick)} />
            <div className="sidebar-widget-container">
              <CButton
                color="ghost"
                onClick={() => setMusicOpen((prev) => !prev)}
                className="w-100 d-flex align-items-center justify-content-between"
                style={{ color: '#F1F5F9', border: '1px solid rgba(241, 245, 249, 0.2)' }}
              >
                <span>
                  <CIcon icon={cilMusicNote} className="me-2" />
                  Music Player
                </span>
                <span>{musicOpen ? '▾' : '▸'}</span>
              </CButton>
              {musicOpen && (
                <>
                  <div className="d-flex gap-2 mt-2 mb-2">
                    <CButton color="ghost" size="sm" onClick={() => handleMusicControl('previous')} disabled={!playlistTracks.length} style={{ color: '#F1F5F9', border: '1px solid rgba(241, 245, 249, 0.2)' }}>
                      Prev
                    </CButton>
                    <CButton color="ghost" size="sm" onClick={() => handleMusicControl('toggle')} style={{ color: '#F1F5F9', border: '1px solid rgba(241, 245, 249, 0.2)' }}>
                      {isPlaying ? 'Pause' : 'Play'}
                    </CButton>
                    <CButton color="ghost" size="sm" onClick={() => handleMusicControl('next')} disabled={!playlistTracks.length} style={{ color: '#F1F5F9', border: '1px solid rgba(241, 245, 249, 0.2)' }}>
                      Next
                    </CButton>
                    <CButton color="ghost" size="sm" onClick={() => handleMusicControl('shuffle')} style={{ color: isShuffling ? '#00D4FF' : '#F1F5F9', border: '1px solid rgba(241, 245, 249, 0.2)' }}>
                      Shuffle
                    </CButton>
                  </div>
                  <MusicWidget isCollapsed={sidebarCollapsed} />
                </>
              )}
            </div>
            <div className="sidebar-widget-container">
              <SidebarGptWidget isCollapsed={sidebarCollapsed} />
            </div>
          </SimpleBar>
        </CSidebarNav>
        <CSidebarToggler
          className="d-none d-lg-flex"
          onClick={toggleSidebarCollapsed}
          style={{
            position: 'absolute',
            bottom: '60px',
            right: '20px',
          }}
        />
        {/* Date/Time Display */}
        <div className="datetime-display">
          <p>{currentTime}</p>
        </div>
        <div className="sidebar-widget-container">
          <p>powered by <a href="https://mieros.org" target="_blank" rel="noopener noreferrer">MiEROS</a></p>
        </div>
        
      </CSidebar>
    </>
  );
};

export default withFirebase(React.memo(AppSidebar));
